import { useCallback } from "react";
import { useSelector } from "react-redux";
import { hasTabPermission } from "../utils/tabsUtils";

export const usePermission = () => {
  const { isStudent, userDetails, user, isManager } = useSelector((s) => s.auth);
  const { lang } = useSelector((s) => s.translate);
  const { permissionLlist, permissionFilters } = useSelector((s) => s.uiData);
  const entities = useSelector((s) => s.entities?.list);

  return useCallback(
    (visibleTo) =>
      hasTabPermission(user, userDetails, isStudent, lang, visibleTo, permissionLlist, isManager, entities, permissionFilters),
    [user, userDetails, isStudent, lang, permissionLlist, isManager, entities, permissionFilters]
  );
};
